import React from 'react';
import AppleIcon from '@mui/icons-material/Apple';
import { Box, Button, Typography } from '@mui/material';

export const AppleButton: React.FC = () => {
  return (
    <Button
      variant={'outlined'}
      size={'small'}
      style={{
        color: '#A6A6A6',
        borderColor: '#A6A6A6',
        borderRadius: '10px',
        paddingLeft: '1px',
      }}
    >
      <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
        <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
          <AppleIcon sx={{ fontSize: 32 }} />
        </Box>
        <Box display={'flex'} flexDirection={'column'} alignItems={'start'}>
          <Typography
            variant={'caption'}
            color={'#A6A6A6'}
            style={{ textTransform: 'none', fontSize: '9px' }}
          >
            {'Descargalo en el'}
          </Typography>
          <Typography
            variant={'body2'}
            color={'#A6A6A6'}
            fontWeight={'bold'}
            style={{ textTransform: 'none', marginTop: '-2px' }}
          >
            {'App store'}
          </Typography>
        </Box>
      </Box>
    </Button>
  );
};
